import * as Sentry from '@sentry/react'
import { RouterProvider } from '@tanstack/react-router'
import './App.css'
import { router } from './router'
import { queryClient } from './main'
import { GlobalErrorProvider } from './components/providers/global-error-provider'

function AppContent() {
  return (
    <GlobalErrorProvider
      enabled={true}
      excludeStatusCodes={[401]} // Don't show notifications for auth errors
    >
      <RouterProvider router={router} context={{ queryClient }} />
    </GlobalErrorProvider>
  )
}

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Une erreur est survenue / Something went wrong</h1>
          <p>
            Une erreur inattendue s&apos;est produite. Veuillez rafraîchir la
            page.
            <br />
            An unexpected error occurred. Please refresh the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Rafraîchir / Refresh
          </button>
        </div>
      }
    >
      <AppContent />
    </Sentry.ErrorBoundary>
  )
}

export default App
